module.exports = __webpack_public_path__ + "static/artboard3-a096a6a584523b7ddf8ddf2beb77fae1.png";